import clsx from "clsx";
import styles from "./STInput.module.css";

export const STInput = ({
  label,
  placeholder,
  variant = "dark",
  prefix,
  suffix,
  error,
  disabled,
  type = "text",
  className,
  handleChange,
  ...props
}) => {
  return (
    <div
      className={clsx(
        styles.wrapper,
        styles[variant],
        error && styles.error,
        disabled && styles.disabled,
        className,
      )}
    >
      {label && <label className={styles.label}>{label}</label>}

      <div className={styles.field}>
        {prefix && <span className={styles.prefix}>{prefix}</span>}

        <input
          type={type}
          className={styles.input}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
          {...props}
        />

        {suffix && <span className={styles.suffix}>{suffix}</span>}
      </div>

      {error && <p className={clsx(styles.errorText)}>{error}</p>}
    </div>
  );
};
